/***************** oidc.js ********** */
// part of the myStuff login procedure
// imported into main.js

import '../login/sass/login.scss';

var oidc;
var isLoggedInLocally;
var hideLoginOverlay;
var showLoginOverlay;
var userLoggedIn;
var userLoggedOut;
var checkLogin;
var popupLogin;
var logOut;
var setupLoggedInState, setupLoggedOutState;
var onclickToLogoutHandler, onclickToLoginHandler;
// https://stackoverflow.com/a/10170885
var is_stuffapp = /^stuffapp/i.test(navigator.userAgent);
var is_uiwebview = is_stuffapp || /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent);

var _logError = function(error) {
  console.log(JSON.stringify(error));
};

if (window.ffxnzOidc) {
  var idmConfig = {
    authority: APP_CONFIG.idm.authority.default,
    client_id: APP_CONFIG.idm.clientId.default,
    popup_redirect_uri: window.location.origin + APP_CONFIG.idm.popupRedirectUri.default,
    silent_redirect_uri: window.location.origin + APP_CONFIG.idm.silentRedirectUri.default,
    silentRequestTimeout: APP_CONFIG.idm.silentRequestTimeout.default,
    response_type: APP_CONFIG.idm.responseType.default,
    scope: APP_CONFIG.idm.scope.default
  };

  var oidc = window.ffxnzOidc({
    idmConfig: idmConfig,
    log: function(message) { console.log(message) },
  });

  logOut = function() {
    oidc.logOut()
      .then(function() { return userLoggedOut(false) })
      .catch(function(error) {
        _logError('42: ' + error);
        userLoggedOut(true);
      });
  };

  setupLoggedInState = function() {
    $('.stuffLogin')
    .addClass('stuffLogin--logged-in')
    .removeClass('stuffLogin--logged-out')
    .unbind('click')
    .text('');

    onclickToLogoutHandler = $('.stuffLogin--logged-in').click(function() {
      // Send a logout event to our analytics service
      var category = 'sweet-spots';
      var action = 'logout';
      var label = 'referrer:' + document.referrer;
      var value = 1;
      ffx.analytics.sendAnalytics(category, action, label, value);

      // Route the user to the IDM profile page
      document.location.href = idmConfig.authority;
    });
  };

  setupLoggedOutState = function() {
    $('.stuffLogin')
      .addClass('stuffLogin--logged-out')
      .removeClass('stuffLogin--logged-in')
      .text('Login')
      .unbind('click');
    
    
    onclickToLoginHandler = $('.stuffLogin--logged-out').click(function () {
      // Send a login event to our analytics service
      var category = 'sweet-spots';
      var action = 'login';
      var label = 'referrer:' + document.referrer;
      var value = 1;
      ffx.analytics.sendAnalytics(category, action, label, value);
      
      popupLogin();
    });
  };

  userLoggedIn = function(user, hasError) {
    if (!user) {
      setupLoggedOutState();
    } else {
      setupLoggedInState();

      hideLoginOverlay();
    }

    return user;
  };

  userLoggedOut = function(hasError) {
    $('.stuffLogin')
      .addClass('stuffLogin--logged-out')
      .removeClass('stuffLogin--logged-in')
      .text('Login');
  };

  isLoggedInLocally = function() {
    return Cookies.get('account') ? true : false;
  };

  checkLogin = function() {
    if (isLoggedInLocally()) {
      return Promise.resolve(true);
    } else {
      return oidc.silentLogin()
      .then(function(user) {
        return userLoggedIn(user, false)
      })
      .catch(function(error) {
        _logError('120: ' + error);
        userLoggedIn(undefined, true);
      });
    }
  };

  popupLogin = function() {
    oidc.popupLogin()
      .then(function(user) { return userLoggedIn(user, false) })
      .catch(function(error) {
        _logError('130: ' + error);
        userLoggedIn(undefined, true);
      });
  };

  hideLoginOverlay = function() {
    $('.login').fadeOut('slow', function() {
      $('.login')
      .addClass('login--inactive');
    });
  };

  showLoginOverlay = function() {
    $('.login')
      .css({display: "flex"})
      .removeClass('login--inactive');
  };

  // Always check whether user is already logged in on page load 
  // NO - lets remove this and only check when attempt made
  // to use sweet spots tool - JH
    doLogin = function() {
    checkLogin()
    .then(function(areWeLoggedIn) {
      if (areWeLoggedIn && isLoggedInLocally()) {
        setupLoggedInState();
      } else {
        setupLoggedOutState();
      }

      // Register our handlers
      $('#js-login').click(function() {
        // Send a login event to our analytics service
        var category = 'sweet-spots';
        var action = 'login';
        var label = 'referrer:' + document.referrer;
        var value = 1;
        ffx.analytics.sendAnalytics(category, action, label, value);

        popupLogin();
      });

      $('#js-signup').click(function() {
        // Send a register event to our analytics service
        var category = 'sweet-spots';
        var action = 'register';
        var label = 'referrer:' + document.referrer;
        var value = 1;
        ffx.analytics.sendAnalytics(category, action, label, value);

        popupLogin();
      });

      // Prevent click events from getting past .loginBox
      $(".loginBox").click(function(event) {
        event.stopPropagation();
      });


      // Show popup if not logged in
      if (! isLoggedInLocally() && ! is_uiwebview) {
        showLoginOverlay();
      }
    });
      loginCheck = true;
    }
  // set up login state in simple header
    if (! isLoggedInLocally() && ! is_uiwebview) {
    setupLoggedOutState();
    } else {
    setupLoggedInState();
  }
} else {
  _logError(new Error('OIDC not loaded'));
}